import $ from "jquery";

(window as any).$ = $;
(window as any).jQuery = $;

if (import.meta.env.PROD) {
  const retainKeys = ["_grecaptcha", "access_token", "referraltoken", "Permissions", "externalReferralLink"]
  const retainCookies = ["currentUser"]
  const storedVersion = localStorage.getItem("app_version");

  if (storedVersion !== __BUILD_TIME__) {
    const saved: Record<string, string> = {};
    retainKeys.forEach((key) => {
      const val = localStorage.getItem(key);
      if (val !== null) saved[key] = val;
    });

    localStorage.clear();
    sessionStorage.clear();

    Object.entries(saved).forEach(([key, val]) => localStorage.setItem(key, val));

    document.cookie.split(";").forEach((cookie) => {
      const name = cookie.split("=")[0]?.trim();
      if (name && !retainCookies.includes(name))
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    });

    localStorage.setItem("app_version", __BUILD_TIME__);
    window.location.href = window.location.href;

  }
}

async function bootstrap() {
  await import("signalr");
}

bootstrap();

import { createRoot } from "react-dom/client";
import App from "./App";
import { Toaster } from "react-hot-toast";
import "./index.css";
import { GlobalErrorBoundary } from "./components/ErrorBoundary/ErrorBoundary.js";
import store from "./store/store";
import { Provider } from "react-redux";
import "react-tooltip/dist/react-tooltip.css";
import { ThemeProvider } from "@mui/material/styles";
import theme from "./theme";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const rootElement = document.getElementById("root") as HTMLElement;

const siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
const enableCaptcha =
  import.meta.env.VITE_REQUIRED_CAPTCHA === "true";

createRoot(rootElement).render(
  <GlobalErrorBoundary>
    <ThemeProvider theme={theme}>
      <Toaster position="top-right" />

      <Provider store={store}>
        {enableCaptcha && siteKey ? (
          <GoogleReCaptchaProvider
            reCaptchaKey={siteKey}
          >
            <App />
          </GoogleReCaptchaProvider>
        ) : (
          <App />
        )}
      </Provider>
    </ThemeProvider>
  </GlobalErrorBoundary>
);
